'use client';
function composeEventHandlersUtil(...e) {
    return (t)=>{
        e.forEach((e)=>{
            'function' != typeof e || t.isDefaultPrevented() || e(t);
        });
    };
}

export { composeEventHandlersUtil };
